
import React, { useState,  useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import SearchForm from './search-form';

/** 
 * https://www.npmjs.com/package/react-tabs
 * 
 * @props searchCriterias = {}
 * @props diseasesHints   = [ "Cardiology", "Diabetes", "Dermatology", ... ]
 * @props onLookup
*/
const Tabbed = (props) => {
  const { t, i18n } = useTranslation();
  
  console.log('Tabbed() props.onLookup().', JSON.stringify(props.onLookup));
  console.log('Tabbed() props.searchCriterias.', JSON.stringify(props.searchCriterias));
  
  const [tabIndex, setTabIndex] = useState(0);
  const [searchHints1, setSearchHints1] = useState([]);
  const [searchHints2, setSearchHints2] = useState([]);
  const [searchHints3, setSearchHints3] = useState([]);

    useEffect(() => {
        // hintTypes - is array of types of suggerstions to return
        // setHints - reference to function to set search hints
        const fetchResortIndex = async (hintTypes, setHints) => {
            try {
                const response = await fetch('index.php?option=com_kurortlife&task=ajax.getResortIndex&format=json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-Token': (Joomla.getOptions('com_kurortlife.options') || {}).csrfToken || '',
                    },
                    body: JSON.stringify({searchHintsTypes : hintTypes}),
                    signal: controller.signal,
                });
                const data = await response.json();
                if (data && data.index) {
                    // Extract only the keywords from the index data
                    setHints(data.index.map(item => item.keyword));
                }
            } catch (e) {
                // Ignore cancellations caused by cleanup (unmount)
                if (e && e.name === 'AbortError') return;
                console.error("Error fetching resort index:", e);
            }
        };

        // One shared controller aborts all three hint requests on unmount
        const controller = new AbortController();

        fetchResortIndex(['state'],   setSearchHints1);
        fetchResortIndex(['city'],    setSearchHints2);
        fetchResortIndex(['decease'], setSearchHints3);

        return () => controller.abort();
    }, []);

  return (
    <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
        <TabList>
            <Tab>{t('States')}</Tab>
            <Tab>{t('Cities')}</Tab>
            <Tab>{t('Curing Illnesses')}</Tab>
        </TabList>
        <TabPanel>
            <SearchForm tab="States" searchHints={searchHints1} {...props} />
        </TabPanel>
        <TabPanel>
            <SearchForm tab="Cities" searchHints={searchHints2} {...props}/>
        </TabPanel>
        <TabPanel>
            <SearchForm tab="Curing Illnesses" searchHints={searchHints3} {...props}/>
        </TabPanel>
    </Tabs>
  );
};

export default Tabbed;
